<template>
    <div class="videos-container">
        <div class="videos-header">
            <h1 class="videos-title">Nuestros Procesos</h1>
            <p class="videos-subtitle">Mira cómo transformamos gorras paso a paso</p>
        </div>

        <div class="videos-grid">
            <div 
                v-for="video in [...videos].reverse()" 
                :key="video.id"
                class="video-card"
            >
                <div class="video-wrapper">
                    <video
                        :src="video.src"
                        :poster="video.poster"
                        class="video-player"
                        controls
                        preload="metadata"
                        @mouseenter="preloadVideo(video.id)"
                    >
                        Tu navegador no soporta el elemento video.
                    </video>
                    
                    <div class="video-overlay">
                        <button class="play-btn" @click="playVideo(video.id)">
                            <i class="fa fa-play"></i>
                        </button>
                    </div>
                </div>

                <div class="video-info">
                    <h3 class="video-title">{{ video.title }}</h3>
                    <p class="video-description">{{ video.description }}</p>
                    <div class="video-duration">
                        <i class="fa fa-clock"></i>
                        {{ video.duration }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para video grande -->
        <div v-if="showVideoModal" class="video-modal" @click="closeVideoModal">
            <div class="video-modal-content" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title">{{ currentVideo.title }}</h3>
                    <button class="modal-close-btn" @click="closeVideoModal">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                
                <div class="modal-video-container">
                    <video
                        :src="currentVideo.src"
                        :poster="currentVideo.poster"
                        class="modal-video-player"
                        controls
                        autoplay
                        ref="modalVideoPlayer"
                    >
                        Tu navegador no soporta el elemento video.
                    </video>
                </div>

                <div class="modal-video-info">
                    <p class="modal-description">{{ currentVideo.description }}</p>
                    <div class="video-stats">
                        <span class="video-duration-modal">
                            <i class="fa fa-clock"></i>
                            {{ currentVideo.duration }}
                        </span>
                        <span class="video-size">
                            <i class="fa fa-film"></i>
                            {{ currentVideo.size }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideosGallery',
    data() {
        return {
            showVideoModal: false,
            currentVideo: {},
            videos: [
                {
                    id: 1,
                    src: require('@/videos/video_01.mp4'),
                    poster: require('@/videos/video_01.mp4'),
                    title: "Lavado Profundo",
                    description: "Proceso completo de lavado y limpieza de gorras",
                    duration: "2:30",
                    size: "15 MB"
                },
                {
                    id: 2,
                    src: require('@/videos/video_02.mp4'),
                    poster: require('@/videos/video_02.mp4'),
                    title: "Planchado Industrial",
                    description: "Uso de formadora para recuperar la estructura",
                    duration: "1:45",
                    size: "12 MB"
                },
                {
                    id: 3,
                    src: require('@/videos/video_03.mp4'),
                    poster: require('@/videos/video_03.mp4'),
                    title: "Cambio de Botones",
                    description: "Reemplazo de botones dañados o perdidos",
                    duration: "3:15",
                    size: "20 MB"
                },
                {
                    id: 4,
                    src: require('@/videos/video_04.mp4'),
                    poster: require('@/videos/video_04.mp4'),
                    title: "Pintando la Gorra",
                    description: "Despes de lavar y plachar se aplica un acabado de Pintura para que quede como nueva",
                    duration: "1:20",
                    size: "10 MB"
                },
                {
                    id: 5,
                    src: require('@/videos/video_05.mp4'),
                    poster: require('@/videos/video_05.mp4'),
                    title: "Curveado de Visera",
                    description: "Adaptación de visera al contorno facial",
                    duration: "0:45",
                    size: "8 MB"
                },
                {
                    id: 6,
                    src: require('@/videos/video_06.mp4'),
                    poster: require('@/videos/video_06.mp4'),
                    title: "Aplicación de Repelente",
                    description: "Proceso de aplicación de capa protectora",
                    duration: "1:10",
                    size: "9 MB"
                },
                {
                    id: 7,
                    src: require('@/videos/video_07.mp4'),
                    poster: require('@/videos/video_07.mp4'),
                    title: "Sanitización Interior",
                    description: "Limpieza y frescura para el interior de gorras",
                    duration: "0:55",
                    size: "7 MB"
                },
                {
                    id: 8,
                    src: require('@/videos/video_08.mp4'),
                    poster: require('@/videos/video_08.mp4'),
                    title: "Restaurando Gorras",
                    description: "Curveado de la Gorra",
                    duration: "1:30",
                    size: "11 MB"
                },
                {
                    id: 9,
                    src: require('@/videos/video_09.mp4'),
                    poster: require('@/videos/video_09.mp4'),
                    title: "Proceso de Pintado",
                    description: "Técnicas profesionales de pintura en gorras",
                    duration: "2:10",
                    size: "14 MB"
                },
                {
                    id: 10,
                    src: require('@/videos/video_10.mp4'),
                    poster: require('@/videos/video_10.mp4'),
                    title: "Lavado de Materiales Delicados",
                    description: "Cuidado especial para gorras con materiales sensibles",
                    duration: "1:50",
                    size: "13 MB"
                },
                {
                    id: 11,
                    src: require('@/videos/video_11.mp4'),
                    poster: require('@/videos/video_11.mp4'),
                    title: "Proceso de Secado",
                    description: "Técnicas adecuadas de secado para preservar gorras",
                    duration: "1:15",
                    size: "9 MB"
                },
                                {
                    id: 12,
                    src: require('@/videos/video_12.mp4'),
                    poster: require('@/videos/video_12.mp4'),
                    title: "CAPWASHMX Lavado, Planchaso y Secado",
                    description: "Restauramos Gorras, Renovamos tu Outfit",
                    duration: "0:21",
                    size: "9 MB"
                }
            ]
        };
    },
    methods: {
        playVideo(videoId) {
        // Encuentra el video por su id en el array original
        const video = this.videos.find(v => v.id === videoId);
        if (video) {
            this.currentVideo = video;
            this.showVideoModal = true;
            document.body.style.overflow = 'hidden';
            
            this.$nextTick(() => {
                const videoPlayer = this.$refs.modalVideoPlayer;
                if (videoPlayer) {
                    videoPlayer.play().catch(error => {
                        console.log('Reproducción automática bloqueada:', error);
                    });
                }
            });
        }
        },

        closeVideoModal() {
            this.showVideoModal = false;
            this.currentVideo = {};
            document.body.style.overflow = '';
            
            // Pausar video al cerrar el modal
            const video = this.$refs.modalVideoPlayer;
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        },

        preloadVideo(videoId) {
            // Encuentra el video por su id
            const videoObj = this.videos.find(v => v.id === videoId);
            if (videoObj && videoObj.src) {
                const link = document.createElement('link');
                link.rel = 'preload';
                link.as = 'video';
                link.href = videoObj.src;
                document.head.appendChild(link);
            }
        }
    },
    mounted() {
        // Agregar listener para tecla ESC
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.style.overflow = '';
    }
};
</script>

<style scoped>
.videos-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

.videos-header {
    text-align: center;
    margin-bottom: 50px;
}

.videos-title {
    font-size: 2.8rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.videos-subtitle {
    font-size: 1.2rem;
    color: #000;
    font-weight: 300;
}

.videos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
    margin-bottom: 40px;
}

.video-card {
    background: white;
    border-radius: 15px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    overflow: hidden;
}

.video-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.video-wrapper {
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;
    background: #000;
}

.video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.video-wrapper:hover .video-player {
    transform: scale(1.05);
}

.video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: all 0.3s ease;
}

.video-wrapper:hover .video-overlay {
    background: rgba(0, 0, 0, 0.5);
}

.play-btn {
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.play-btn:hover {
    background: white;
    transform: scale(1.1);
    box-shadow: 0 5px 15px rgba(255, 255, 255, 0.3);
}

.play-btn i {
    color: #3498db;
    font-size: 1.5rem;
    margin-left: 3px;
}

.video-info {
    padding: 20px;
}

.video-title {
    font-size: 1.3rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 10px;
    line-height: 1.3;
}

.video-description {
    color: #7f8c8d;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 15px;
}

.video-duration {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f8f9fa;
    color: #5a6c7d;
    padding: 6px 12px;
    border-radius: 15px;
    font-size: 0.85rem;
    font-weight: 500;
}

.video-duration i {
    color: #3498db;
    font-size: 0.8rem;
}

/* Modal de Video */
.video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
}

.video-modal-content {
    width: 90vw;
    max-width: 1000px;
    background: #1a1a1a;
    border-radius: 15px;
    overflow: hidden;
    cursor: default;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    background: rgba(0, 0, 0, 0.8);
    border-bottom: 1px solid #333;
}

.modal-title {
    color: white;
    font-weight: 600;
    font-size: 1.4rem;
    margin: 0;
}

.modal-close-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
}

.modal-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.modal-video-container {
    width: 100%;
    background: #000;
}

.modal-video-player {
    width: 100%;
    height: auto;
    max-height: 70vh;
    outline: none;
}

.modal-video-info {
    padding: 20px 25px;
    background: rgba(0, 0, 0, 0.8);
    border-top: 1px solid #333;
}

.modal-description {
    color: #e0e0e0;
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 15px;
}

.video-stats {
    display: flex;
    gap: 20px;
    align-items: center;
}

.video-duration-modal,
.video-size {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #b0b0b0;
    font-size: 0.9rem;
}

.video-duration-modal i,
.video-size i {
    color: #3498db;
    font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .videos-grid {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 25px;
    }
}

@media (max-width: 768px) {
    .videos-container {
        padding: 30px 15px;
    }
    
    .videos-title {
        font-size: 2.2rem;
    }
    
    .videos-subtitle {
        font-size: 1.1rem;
    }
    
    .videos-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .video-wrapper {
        height: 200px;
    }
    
    .video-modal-content {
        width: 95vw;
        margin: 20px;
    }
    
    .modal-header {
        padding: 15px 20px;
    }
    
    .modal-title {
        font-size: 1.2rem;
    }
    
    .modal-video-info {
        padding: 15px 20px;
    }
}

@media (max-width: 480px) {
    .videos-title {
        font-size: 1.8rem;
    }
    
    .videos-subtitle {
        font-size: 1rem;
    }
    
    .video-wrapper {
        height: 180px;
    }
    
    .video-info {
        padding: 15px;
    }
    
    .video-title {
        font-size: 1.1rem;
    }
    
    .play-btn {
        width: 50px;
        height: 50px;
    }
    
    .play-btn i {
        font-size: 1.2rem;
    }
    
    .video-stats {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
}
</style>